import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { TextSizeType } from '../../../../../theme/type/text-type';
import { cn, textSizeClass } from '../../../../../utils/tailwind';

interface SelectValueProps {
    option: string | number | Array<string | number> | null;
    label: string | undefined;
    IconComponent?: React.ReactNode;
    labelSize?: TextSizeType;
    translationKey?: string;
}

export const SelectValue = (props: SelectValueProps) => {
    const { t } = useTranslation();
    const labelSizeClass = props.labelSize ? textSizeClass[props.labelSize] : 'text-medium';

    if (props.translationKey) {
        if (Array.isArray(props.option)) {
            return (
                <span className="flex w-full items-center">
                    <span className={cn('flex-1 antialiased', labelSizeClass)}>
                        {props.option
                            .map((optionValue) => {
                                return t(`${props.translationKey}.${optionValue}`);
                            })
                            .join(', ')}
                    </span>
                </span>
            );
        }
        return (
            <span className="flex w-full items-center">
                <span className={cn('flex-1 antialiased', labelSizeClass)}>
                    {t(`${props.translationKey}.${props.option}`)}
                </span>
            </span>
        );
    }

    if (Array.isArray(props.option)) {
        return (
            <span className="flex w-full items-center">
                <span className={cn('flex-1 antialiased', labelSizeClass)}>
                    {props.option
                        .map((optionValue) => {
                            return optionValue;
                        })
                        .join(', ')}
                </span>
            </span>
        );
    }
    return (
        <span className="flex w-full items-center">
            <span className={cn('flex-1 antialiased', labelSizeClass)}>
                {props.option ? props.option.toString() : ''}
            </span>
        </span>
    );
};
